import { Collapse } from 'antd'
import { CollapsePanelProps, CollapseProps } from 'antd/lib/collapse'
import React from 'react'
import classnames from 'classnames'
import './index.scss'

interface Props {
  collapseProps?: CollapseProps
  panelProps: CollapsePanelProps // Panel props must pass 'header: ReactNode' and 'key: string | number'
  defaultActive?: boolean
  children?: any
}

export const SingleCollapsibleContainer = (props: Props) => {
  const { collapseProps, panelProps, defaultActive } = props
  const defaultActiveKey = defaultActive ? panelProps.key : undefined

  return (
    <Collapse
      {...collapseProps}
      className={classnames(collapseProps?.className, 'single-collapsible-container')}
      defaultActiveKey={defaultActiveKey}
    >
      <Collapse.Panel {...panelProps}>{props.children}</Collapse.Panel>
    </Collapse>
  )
}
